// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-y: scroll
}

.no-style {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.no-scroll {
  overflow: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.navbar {
  padding: 0;
}

.navbar-nav {
  position: relative;
  align-items: center;
  height: 80px;
}

.navbar-nav .active {
  color: white !important;
  background-color: #4f8d96;
  border: 1px solid #4f8d96;
}

.navbar-nav a {
  height: 100%;
  display: flex;
  align-items: center;
}

.nav-link {
  color: black;
  background-color: #FFFFFF;
  border: 1px solid black;
  margin-top: 5px;
  border-radius: 5px;
  padding: 8px 25px !important;
  width: 70%;
  text-align: center;
  justify-content: center;
}

.nav-link:not(.active):hover {
  background-color: #cdcdcd;
}

.nav-link:focus {
  outline: 0;
  box-shadow: none;
  /*box-shadow: 0 0 0 0.20rem rgb(79, 141, 150, 0.6);*/
}

.link {
  color: #76AEB7;
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
  padding: 4px;
}

.form-switch {
  margin-bottom: 0;
}

.form-switch .form-check-input {
  width: 50px;
  height: 25px;
  border: 2px solid #4f8d96;
  outline: 0;
  cursor: pointer;
}

.form-switch .form-check-input:focus {
  box-shadow: none;
}

.form-switch .form-check-input:checked {
  background-color: #4f8d96;
}

.form-control {
  background-color: #fff;
  color: #333;
  border: 0;
  outline: 1px solid #B3B3B3;
  padding: 7px 15px;
  margin-top: 2px;
}

.form-control:focus {
  border: 0;
  outline: 2px solid #76AEB7;
  box-shadow: none;
  background-color: #f9f9f9;
}

.progress .progress-bar {
  background-color: #4f8d96;
}

.invoicesTotals {
  width: 400px;
  max-width: 400px;
  float: right;
}

.invoicesTotals td {
  border: 1px solid gray;
  padding: 5px;
}

.invoicesTableContainer {
  width: 100%;
  overflow-x: auto;
  margin: 0 auto;
  position: relative;
  margin-bottom: 50px;
}

.invoicesTable {
  width: 100%;
}

.invoicesTable th {
  background-color: #F1FDFF;
}

.invoicesTable tr,
.invoicesTable td,
.invoicesTable th {
  border: 1px solid gray;
}

.invoicesTable .even-row {
  background-color: #E9ECEF;
}

.invoicesTable .trans-fail {
  background: rgba(219, 65, 44, 0.3);
}

.tableActions span {
  cursor: pointer;
}

.tableActions span:hover {
  cursor: pointer;
  color: #4f8d96;
}

.btn-primary, .btn-primary:disabled {
  --bs-btn-active-bg: #76AEB7;
  --bs-btn-active-border-color: #76AEB7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  background-color: #76AEB7;
  border: 1px solid #76AEB7;
  padding: 15px 40px;
}

.btn-primary:hover {
  background-color: #4f8d96;
  border: 1px solid #4f8d96;
}

.btn-primary:focus {
  outline: 0;
  background-color: #4f8d96;
  box-shadow: 0 0 0 0.20rem rgb(79, 141, 150, 0.6);
}

.btn-mydatasearch {
  width: 100%;
}

.btn-qr {
  border: 1px solid #76AEB7;
  outline: 1px solid #76AEB7;
  padding: 0 30px;
  margin-top: 2px;
}

.page-link:not(.active), .page-link:hover  {
  color: #76AEB7;
  border: 1px solid #76AEB7;
}

.page-link:focus {
  outline: 0;
  box-shadow: 0 0 0 0.20rem rgb(79, 141, 150, 0.6);
}

.active .page-link {
  background-color: #4f8d96;
  color: #f9f9f9;
}

.primary-card {
  border: 1px solid #4f8d96;
  min-height: 100%;
  background-color: #F9F9F9;
  box-shadow: rgba(0, 0, 0, 0.16) 0 3px 6px, rgba(0, 0, 0, 0.23) 0 3px 6px;
}

.myData-card {
  min-height: 0;
}

.correlated-card {
  border: 1px solid #4f8d96 !important;
}
.primary-card .card-title {
  background-color: #4f8d96;
  color: #f9f9f9;
}

.primary-card .card-text div {
  border-bottom: 1px solid;
}

.primary-card .card-text .invoiceValue {
  max-width: 70%;
  text-align: end;
}

.primary-card .card-text div:last-child {
  border-bottom: 0;
}

.alt-card {
  border: 1px solid #4f8d96;
  border-radius: 4px;
  min-height: 100%;
  background-color: #FFFFFF;
}

.paymentMethod-card {
  border: 1px solid #4f8d96;
  min-height: 100%;
  background-color: #F9F9F9;
}

.taxesTotals-card {
  border: 1px solid #4f8d96;
  min-height: 100%;
  background-color: #F9F9F9;
}

.card-title {
  border-bottom: 1px solid #4f8d96;
}

.alt-card .card-title {
  font-size: 13px;
  background-color: #76AEB7;
  border-bottom: 1px solid #76AEB7;
}

.alt-card .card-text {
  font-size: 13px;
}

.alt-card .card-body {
  padding: 0;
}

.alt-card .card-text .content {
  padding: 0 5px;
}

.alt-card .card-text .invoiceValue {
  max-width: 70%;
  text-align: end;
}

.classification {
  margin-left: 10px;
}

.selected-row {
  background-color: #4f8d96;
  color: #FFFFFF;
}

.selected-row tr, .selected-row td, .selected-row th {
  border: 1px solid white !important;
}

.qr-modal {
  padding: 2px;
  height: 400px;
  width: 100%;
}

.qr-modal video {
  height: 100%;
  width: 100%;
}

.settingsContainer {
    display: flex;
}

.rightOfSidebarContent {
  flex: 1 1;
}

.app-navbar-nav {
  padding: 20px 0;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: #f1fdff;
  box-shadow: rgba(0, 0, 0, 0.16) 0 3px 6px, rgba(0, 0, 0, 0.23) 0 3px 6px;
}

.user-info {
  min-width: 237px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #333333;
}

.user-info span {
  text-align: center;
}

.user-info button {
  height: 40px;
}

.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 50;
}

@media (min-width: 768px) {
  .btn-mydatasearch {
    width: auto;
  }
  .qr-modal {
    padding: 16px;
    height: 400px;
    width: 100%;
  }
  .app-navbar-nav {
    position: unset;
    padding: 0;
    box-shadow: unset;
  }
  .user-info {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 20px;
    border: unset;
  }
  .nav-link {
    width: unset;
    justify-content: center;
    background-color: unset;
    border: unset;
    border-radius: unset;
    margin: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC;AACF;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,UAAU;EACV,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,4DAA4D;EAC5D,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,wEAAwE;AAC1E;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,wEAAwE;AAC1E;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,aAAa;IACb,WAAW;EACb;EACA;IACE,eAAe;IACf,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;EACA;IACE,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;IACb,oBAAoB;IACpB,aAAa;EACf;AACF","sourcesContent":["body {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  overflow-y: scroll\r\n}\r\n\r\n.no-style {\r\n  text-decoration: none;\r\n  color: inherit;\r\n  cursor: pointer;\r\n}\r\n\r\n.no-scroll {\r\n  overflow: hidden;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n.navbar {\r\n  padding: 0;\r\n}\r\n\r\n.navbar-nav {\r\n  position: relative;\r\n  align-items: center;\r\n  height: 80px;\r\n}\r\n\r\n.navbar-nav .active {\r\n  color: white !important;\r\n  background-color: #4f8d96;\r\n  border: 1px solid #4f8d96;\r\n}\r\n\r\n.navbar-nav a {\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.nav-link {\r\n  color: black;\r\n  background-color: #FFFFFF;\r\n  border: 1px solid black;\r\n  margin-top: 5px;\r\n  border-radius: 5px;\r\n  padding: 8px 25px !important;\r\n  width: 70%;\r\n  text-align: center;\r\n  justify-content: center;\r\n}\r\n\r\n.nav-link:not(.active):hover {\r\n  background-color: #cdcdcd;\r\n}\r\n\r\n.nav-link:focus {\r\n  outline: 0;\r\n  box-shadow: none;\r\n  /*box-shadow: 0 0 0 0.20rem rgb(79, 141, 150, 0.6);*/\r\n}\r\n\r\n.link {\r\n  color: #76AEB7;\r\n  text-decoration: underline;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n}\r\n\r\n.form-switch {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.form-switch .form-check-input {\r\n  width: 50px;\r\n  height: 25px;\r\n  border: 2px solid #4f8d96;\r\n  outline: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.form-switch .form-check-input:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.form-switch .form-check-input:checked {\r\n  background-color: #4f8d96;\r\n}\r\n\r\n.form-control {\r\n  background-color: #fff;\r\n  color: #333;\r\n  border: 0;\r\n  outline: 1px solid #B3B3B3;\r\n  padding: 7px 15px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.form-control:focus {\r\n  border: 0;\r\n  outline: 2px solid #76AEB7;\r\n  box-shadow: none;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.progress .progress-bar {\r\n  background-color: #4f8d96;\r\n}\r\n\r\n.invoicesTotals {\r\n  width: 400px;\r\n  max-width: 400px;\r\n  float: right;\r\n}\r\n\r\n.invoicesTotals td {\r\n  border: 1px solid gray;\r\n  padding: 5px;\r\n}\r\n\r\n.invoicesTableContainer {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  margin: 0 auto;\r\n  position: relative;\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.invoicesTable {\r\n  width: 100%;\r\n}\r\n\r\n.invoicesTable th {\r\n  background-color: #F1FDFF;\r\n}\r\n\r\n.invoicesTable tr,\r\n.invoicesTable td,\r\n.invoicesTable th {\r\n  border: 1px solid gray;\r\n}\r\n\r\n.invoicesTable .even-row {\r\n  background-color: #E9ECEF;\r\n}\r\n\r\n.invoicesTable .trans-fail {\r\n  background: rgba(219, 65, 44, 0.3);\r\n}\r\n\r\n.tableActions span {\r\n  cursor: pointer;\r\n}\r\n\r\n.tableActions span:hover {\r\n  cursor: pointer;\r\n  color: #4f8d96;\r\n}\r\n\r\n.btn-primary, .btn-primary:disabled {\r\n  --bs-btn-active-bg: #76AEB7;\r\n  --bs-btn-active-border-color: #76AEB7;\r\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n  background-color: #76AEB7;\r\n  border: 1px solid #76AEB7;\r\n  padding: 15px 40px;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: #4f8d96;\r\n  border: 1px solid #4f8d96;\r\n}\r\n\r\n.btn-primary:focus {\r\n  outline: 0;\r\n  background-color: #4f8d96;\r\n  box-shadow: 0 0 0 0.20rem rgb(79, 141, 150, 0.6);\r\n}\r\n\r\n.btn-mydatasearch {\r\n  width: 100%;\r\n}\r\n\r\n.btn-qr {\r\n  border: 1px solid #76AEB7;\r\n  outline: 1px solid #76AEB7;\r\n  padding: 0 30px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.page-link:not(.active), .page-link:hover  {\r\n  color: #76AEB7;\r\n  border: 1px solid #76AEB7;\r\n}\r\n\r\n.page-link:focus {\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.20rem rgb(79, 141, 150, 0.6);\r\n}\r\n\r\n.active .page-link {\r\n  background-color: #4f8d96;\r\n  color: #f9f9f9;\r\n}\r\n\r\n.primary-card {\r\n  border: 1px solid #4f8d96;\r\n  min-height: 100%;\r\n  background-color: #F9F9F9;\r\n  box-shadow: rgba(0, 0, 0, 0.16) 0 3px 6px, rgba(0, 0, 0, 0.23) 0 3px 6px;\r\n}\r\n\r\n.myData-card {\r\n  min-height: 0;\r\n}\r\n\r\n.correlated-card {\r\n  border: 1px solid #4f8d96 !important;\r\n}\r\n.primary-card .card-title {\r\n  background-color: #4f8d96;\r\n  color: #f9f9f9;\r\n}\r\n\r\n.primary-card .card-text div {\r\n  border-bottom: 1px solid;\r\n}\r\n\r\n.primary-card .card-text .invoiceValue {\r\n  max-width: 70%;\r\n  text-align: end;\r\n}\r\n\r\n.primary-card .card-text div:last-child {\r\n  border-bottom: 0;\r\n}\r\n\r\n.alt-card {\r\n  border: 1px solid #4f8d96;\r\n  border-radius: 4px;\r\n  min-height: 100%;\r\n  background-color: #FFFFFF;\r\n}\r\n\r\n.paymentMethod-card {\r\n  border: 1px solid #4f8d96;\r\n  min-height: 100%;\r\n  background-color: #F9F9F9;\r\n}\r\n\r\n.taxesTotals-card {\r\n  border: 1px solid #4f8d96;\r\n  min-height: 100%;\r\n  background-color: #F9F9F9;\r\n}\r\n\r\n.card-title {\r\n  border-bottom: 1px solid #4f8d96;\r\n}\r\n\r\n.alt-card .card-title {\r\n  font-size: 13px;\r\n  background-color: #76AEB7;\r\n  border-bottom: 1px solid #76AEB7;\r\n}\r\n\r\n.alt-card .card-text {\r\n  font-size: 13px;\r\n}\r\n\r\n.alt-card .card-body {\r\n  padding: 0;\r\n}\r\n\r\n.alt-card .card-text .content {\r\n  padding: 0 5px;\r\n}\r\n\r\n.alt-card .card-text .invoiceValue {\r\n  max-width: 70%;\r\n  text-align: end;\r\n}\r\n\r\n.classification {\r\n  margin-left: 10px;\r\n}\r\n\r\n.selected-row {\r\n  background-color: #4f8d96;\r\n  color: #FFFFFF;\r\n}\r\n\r\n.selected-row tr, .selected-row td, .selected-row th {\r\n  border: 1px solid white !important;\r\n}\r\n\r\n.qr-modal {\r\n  padding: 2px;\r\n  height: 400px;\r\n  width: 100%;\r\n}\r\n\r\n.qr-modal video {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.settingsContainer {\r\n    display: flex;\r\n}\r\n\r\n.rightOfSidebarContent {\r\n  flex: 1;\r\n}\r\n\r\n.app-navbar-nav {\r\n  padding: 20px 0;\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  width: 100%;\r\n  background-color: #f1fdff;\r\n  box-shadow: rgba(0, 0, 0, 0.16) 0 3px 6px, rgba(0, 0, 0, 0.23) 0 3px 6px;\r\n}\r\n\r\n.user-info {\r\n  min-width: 237px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-top: 1px solid #333333;\r\n}\r\n\r\n.user-info span {\r\n  text-align: center;\r\n}\r\n\r\n.user-info button {\r\n  height: 40px;\r\n}\r\n\r\n.menu-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.4);\r\n  z-index: 50;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .btn-mydatasearch {\r\n    width: auto;\r\n  }\r\n  .qr-modal {\r\n    padding: 16px;\r\n    height: 400px;\r\n    width: 100%;\r\n  }\r\n  .app-navbar-nav {\r\n    position: unset;\r\n    padding: 0;\r\n    box-shadow: unset;\r\n  }\r\n  .user-info {\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 20px;\r\n    border: unset;\r\n  }\r\n  .nav-link {\r\n    width: unset;\r\n    justify-content: center;\r\n    background-color: unset;\r\n    border: unset;\r\n    border-radius: unset;\r\n    margin: unset;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
